class User{
    id: number;
    name: string;
}

class repositoryLite{
    id: string;
    title: string;
}

export class RepositoryPermission{
    id: string;
    user: User = new User();
    repositories: repositoryLite[];
}
